(function () {
  let config = null;

  function getConfig() {
    if (config) return config;

    const el = document.getElementById('bz-shipping-config');
    if (!el) return null;

    try {
      config = JSON.parse(el.textContent);
      return config;
    } catch {
      return null;
    }
  }

  async function getCart() {
    try {
      const res = await fetch('/cart.js', {
        credentials: 'same-origin',
        cache: 'no-store',
      });
      if (!res.ok) return null;
      return await res.json();
    } catch {
      return null;
    }
  }

  function formatMoney(cents, currency = 'CAD') {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency,
    }).format(cents / 100);
  }

  async function render() {
    const cfg = getConfig();
    if (!cfg || !cfg.showBar) return;

    const cart = await getCart();
    if (!cart) return;

    const subtotal = cart.items_subtotal_price;
    const threshold = cfg.thresholdCents;
    const currency = cfg.currencyCode || 'CAD';
    const country = (cfg.countryCode || '').toUpperCase();

    // Preserve existing threshold calculations for all markets.
    const remaining = Math.max(threshold - subtotal, 0);
    const progress =
      threshold > 0 ? Math.min((subtotal / threshold) * 100, 100) : 0;

    // Free shipping without minimums applies only to Canada and USA.
    const hasFreeShipping = country === 'CA' || country === 'US';

    document.querySelectorAll('[data-bz-shipping-root]').forEach((root) => {
      const message = root.querySelector('[data-bz-shipping-message]');
      const bar = root.querySelector('[data-bz-shipping-progress-bar]');

      if (message) {
        if (hasFreeShipping) {
          // Canada and USA: free shipping regardless of cart subtotal.
          message.textContent = 'FREE SHIPPING ON ALL ORDERS · NO MINIMUMS';
        } else {
          // All other countries: preserve existing shipping messages.
          const isEmpty = subtotal === 0;

          if (isEmpty) {
            message.textContent =
              `Complimentary Shipping On Orders Over ${formatMoney(threshold, currency)}`;
          } else if (remaining > 0) {
            message.textContent =
              `${formatMoney(remaining, currency)} Away From Complimentary Shipping`;
          } else {
            message.textContent = 'Complimentary Shipping Applied';
          }
        }
      }

      if (bar) {
        if (hasFreeShipping) {
          // Hide the progress indicator for Canada and USA.
          bar.style.width = '0%';
          bar.style.display = 'none';
        } else {
          // Restore and update the progress indicator internationally.
          bar.style.display = '';
          bar.style.width = `${Math.round(progress)}%`;
        }
      }
    });

    // 🔥 Notify upsell (preserved).
    document.dispatchEvent(
      new CustomEvent('bz:shipping:updated', {
        detail: { subtotal },
      })
    );
  }

  function observeDrawer() {
    let queued = false;

    const observer = new MutationObserver((mutations) => {
      const shippingRootChanged = mutations.some((mutation) => {
        return Array.from(mutation.addedNodes).some((node) => {
          if (!(node instanceof HTMLElement)) return false;

          return (
            node.matches?.('[data-bz-shipping-root]') ||
            node.querySelector?.('[data-bz-shipping-root]')
          );
        });
      });

      if (!shippingRootChanged || queued) return;

      queued = true;

      requestAnimationFrame(() => {
        queued = false;
        render();
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  function init() {
    // Initial
    render();

    // Horizon updates
    document.addEventListener('cart:update', render);

    // 🔥 CRITICAL: handle DOM replacement
    observeDrawer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();